import moment from "moment";

import { CROP_TYPE_FCPO, CropItemData, FieldPracticeResponse, GROUP_TYPE, PRACTICE_TYPE, TimelineCalendarItemsProps } from "models";

export const getCropGroupType = (cropType: CROP_TYPE_FCPO) => {
  switch (cropType) {
    case CROP_TYPE_FCPO.MAIN:
      return GROUP_TYPE.MAIN_CROP;
    case CROP_TYPE_FCPO.COVER:
    case CROP_TYPE_FCPO.UNDERSOWING:
      return GROUP_TYPE.SIDE_CROP;
    default:
      return GROUP_TYPE.MAIN_CROP;
  }
};

export const getCropPracticeType = (cropType: CROP_TYPE_FCPO) => {
  switch (cropType) {
    case CROP_TYPE_FCPO.MAIN:
      return PRACTICE_TYPE.MAIN_CROP;
    case CROP_TYPE_FCPO.UNDERSOWING:
      return PRACTICE_TYPE.UNDERSOWING_CROP;
    case CROP_TYPE_FCPO.COVER:
      return PRACTICE_TYPE.COVER_CROP;
    default:
      return PRACTICE_TYPE.UNKNOWN;
  }
};

export const createCropItems = (
  fieldCropOverviewResponse: FieldPracticeResponse,
  baselineYears: number[],
  isMandatory: boolean
): TimelineCalendarItemsProps<CropItemData>[] =>
  fieldCropOverviewResponse.crops.map((crop) => {
    const item: TimelineCalendarItemsProps<CropItemData> = {
      id: crop.id,
      title: crop.cropName,
      start_time: moment(crop.seedingStartDate ?? crop.fallbackDates.seedingStartDate),
      end_time: moment(crop.harvestEndDate ?? crop.fallbackDates.harvestEndDate),
      group: getCropGroupType(crop.cropType as CROP_TYPE_FCPO),
      // TODO: re-add resizing
      // canResize: "both",
      canResize: false,
      cropItemId: crop.id,
      practiceType: getCropPracticeType(crop.cropType as CROP_TYPE_FCPO),
      data: {
        cropType: crop.cropType,
        cropName: crop.cropName,
        fieldId: "6b4a8b5f-2680-4013-8137-67ca4d5550c9",
        hasResidue: crop.hasResidue,
        isMandatory: isMandatory,
        isBaseline: baselineYears.includes(crop.year!),
        isConfirmed: !!crop.isConfirmed,
        year: crop.year,
        fertilizerManagements: fieldCropOverviewResponse.fertilizerManagements,
        yieldPerHa: crop.yieldPerHa,
        yieldPerHaUnit: crop.yieldPerHaUnit,
        cropMixId: crop.cropMixId,
        hasMissingGrowingDates: crop.seedingStartDate === null || crop.harvestEndDate === null,
        yieldSoilPlus3DataCollection: crop.yieldSoilPlus3DataCollection,
        growingDatesSoilPlus3DataCollection: crop.growingDatesSoilPlus3DataCollection,
        seedingSoilPlus3DataCollection: crop.seedingSoilPlus3DataCollection,
      },
    };
    return item;
  });
